<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div  slot="header" class="flexContainer">
        <span  class="cardHeader">角色管理</span>
        <el-button style="float:right;" type="primary" size="default" @click="createClickHandler">添加新角色</el-button>
      </div>

      <!-- 搜索条 -->
      <div>
        <el-form :model="queryInfo" :inline="true" size="normal">
          <el-form-item label="关键词：">
            <el-input clearable v-model="queryInfo.query" placeholder="关键字" @clear="getList(true)"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(true)">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <el-table :data="list" style="margin-top:0px" ref="table">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div style="margin-left:60px">
              <el-row :gutter="20">
                <el-col :span="5" :offset="0">
                  <div><strong>角色菜单</strong></div>
                  <el-tree ref="tree" :data="scope.row.menus" node-key="_id"
                  :props="defaultProps" ></el-tree>
                </el-col>
                <el-col :span="19" :offset="0">
                  <!-- <div style="color:#409EFF"><strong>操作权限</strong></div> -->
                  <template v-for="(item,index) in scope.row.rights">
                    <div :key="'right_'+index"><strong>{{item.name}}</strong></div>
                    <ul :key="item._id" style="list-style:circle;display:flex;padding-inline-start: 20px;padding-top: 14px;padding-bottom: 14px;">
                      <li style="margin-right:35px" v-for="(t,i) in item.actions" :key="'action_'+i">{{t}}</li>
                    </ul>
                  </template>
                </el-col>
              </el-row>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="编号" type="index" width="60"></el-table-column>
        <el-table-column label="角色名称" prop="name" width="130"></el-table-column>
        <el-table-column label="角色描述" prop="desc" show-overflow-tooltip></el-table-column>
        <el-table-column label="菜单和权限" width="120">
          <template slot-scope="scope">
            <el-link type="primary" :underline="true" href="" @click.prevent="expandRow(scope.row)">点击查看</el-link>
          </template>
        </el-table-column>
        <el-table-column label="AI工具" width="96" align="center">
          <template slot-scope="scope">
            <el-link v-if="scope.row.assistantToolCount > 0" type="primary" :underline="false" href="" @click.prevent="assistantClickHandler(scope.row)">{{ scope.row.assistantToolCount }} 个</el-link>
            <span v-else class="assistant-none">未配置</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="350">
          <template slot-scope="scope">
            <el-button type="primary" plain size="small" @click="modifyClickHandler(scope.row)">修改</el-button>
            <el-button type="primary" plain size="small" @click="assistantClickHandler(scope.row)">配置助手权限</el-button>
            <el-button type="primary" plain size="small" @click="cleanupClickHandler(scope.row)">清空权限</el-button>
            <el-button type="primary" plain size="small" @click="deleteClickHandler(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10,20,50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

  </div>
</template>

<script>
import Menu from '../../utility/menu.js'
export default {
  data () {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      list: [],
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 10
      },
      total: 0
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取列表
    async getList (flush = false) {
      if (flush === true) this.queryInfo.pagenum = 1
      const { data: res } = await this.$http.get('role/list', { params: this.queryInfo })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      res.data.list.forEach(e => {
        e.menus = Menu.castMenu(e.menuIds)
        delete e.menuIds
      })
      this.list = res.data.list
      this.total = res.data.total
    },

    // 展开行
    expandRow (row) {
      this.$refs.table.toggleRowExpansion(row)
    },

    // 监听pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getList()
    },

    // 监听页码改变
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getList()
    },

    // 点击添加按钮
    async createClickHandler () {
      this.$router.push('/role/add')
    },

    // 点击修改按钮
    async modifyClickHandler (row) {
      this.$router.push(`/role/modify/${row._id}`)
    },

    // 进入该角色的智能助手授权配置页（计数列同款入口）
    assistantClickHandler (row) {
      this.$router.push(`/role/assistant/${row._id}`)
    },

    async cleanupClickHandler (row) {
      const confirmResult = await this.$confirm(
        '确定要清空吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      const { data: res } = await this.$http.put(`role/cleanup/${row._id}`)

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success(res.meta.msg)
      this.getList()
    },

    // 点击删除按钮
    async deleteClickHandler (row) {
      const confirmResult = await this.$confirm(
        '确定要删除吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      const { data: res } = await this.$http.delete(`role/remove/${row._id}`)

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success(res.meta.msg)
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.assistant-none {
  font-size: 12px;
  color: #8a94a6;
}
</style>
